import type { SmallStepKey } from '@wre/infinity-generators/i18n';
import type { BlockId } from './Block';
import type { QuestionTypeModel } from './QuestionTypeModel';

export type SmallStepId = BlockId & { smallStep: SmallStepKey };

/**
 * All of the information we store about a small step.
 */
export interface SmallStepContent {
  smallStep: SmallStepKey;
  /**
   * List of UIDs which are part of this small step, in order.
   */
  questionTypes: string[];
  archivedQuestionTypes: string[];
  /**
   * Module containing the actual questions, and their schemas. We just type these as unknown in order to avoid TS
   * getting confused over other exported constants. However, this means that to get the question types out you will
   * need to cast.
   */
  module: () => Promise<Record<string, unknown>>;
}

export function newSmallStepContent<UID extends string>(params: {
  smallStep: SmallStepKey;
  questionTypes: UID[];
  archivedQuestionTypes?: UID[];
  // Some extra typesafety here - check that the UIDs mentioned above are actually defined in the module here.
  // Note that we don't hold on to the type information of the specific UIDs - the return value of this function
  // just uses `string`.
  module: () => Promise<Record<`${UID}Model`, QuestionTypeModel>>;
}): SmallStepContent {
  return {
    smallStep: params.smallStep,
    questionTypes: params.questionTypes,
    archivedQuestionTypes: params.archivedQuestionTypes ?? [],
    module: params.module
  };
}
